// src/index.js
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { configureStore } from '@reduxjs/toolkit';
import { HelmetProvider } from 'react-helmet-async';

import rootReducer from './reducers';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { setupAxiosInterceptors } from './utils/axiosConfig';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import './css/style.css';
// import './css/icon-font.css';

// 1) Store (devTools auto-enabled in development by RTK)
const store = configureStore({ reducer: rootReducer });

// 2) Setup axios interceptors for 401 handling and token refresh
setupAxiosInterceptors(store);

// 2) Stripe (safe if env var is missing)
const stripeKey = process.env.REACT_APP_STRIPE_KEY;
const stripePromise = stripeKey ? loadStripe(stripeKey) : null;

// 3) Mount
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <BrowserRouter>
          {/* Suspense enables lazy-loaded routes/components */}
          <Suspense fallback={<div style={{ padding: 16 }}>Loading…</div>}>
            {stripePromise ? (
              <Elements stripe={stripePromise}>
                <App />
              </Elements>
            ) : (
              <App />
            )}
          </Suspense>
        </BrowserRouter>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);

// Optional: performance reporting
reportWebVitals();

// Register service worker for PWA functionality
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('App is ready for offline use');
  },
  onUpdate: (registration) => {
    // Notify user that a new version is available
    const updateAvailable = window.confirm(
      'New content is available! Click OK to refresh and get the latest version.'
    );
    if (updateAvailable && registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      window.location.reload();
    }
  }
});
